import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { ImageViewer } from 'components/ImageViewer';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import GrouploancontractViewPage from 'pages/grouploancontract/View';
import MembermasterViewPage from 'pages/membermaster/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const LoanguarantorListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/loanguarantor/view/${data.guarantorid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('loanguarantor/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/loanguarantor/edit/${data.guarantorid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('loanguarantor/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.guarantorid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('loanguarantor/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function GuarantoridTemplate(data){
		if(data){
			return (
				<Link to={`/loanguarantor/view/${data.guarantorid}`}> { data.guarantorid }</Link>
			);
		}
	}
	function LoanaccountnoTemplate(data){
		if(data){
			return (
				<>{data.loanaccountno && <Button className="p-button-text" icon="pi pi-eye" label={$t('grouploancontract')} onClick={() => app.openPageDialog(<GrouploancontractViewPage isSubPage apiPath={`/grouploancontract/view/${data.loanaccountno}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function MemberidTemplate(data){
		if(data){
			return (
				<>{data.memberid && <Button className="p-button-text" icon="pi pi-eye" label={$t('membermaster')} onClick={() => app.openPageDialog(<MembermasterViewPage isSubPage apiPath={`/membermaster/view/${data.memberid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function PhotoTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.photo} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function IdImageTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.id_image} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-loanguarantor`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="loanguarantor/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="LoanguarantorListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('loanGuarantor')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <Link to={`/loanguarantor/add`}>
                        <Button label={$t('addNewGuarantor')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="guarantorid" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="guarantorid" header={$t('guarantorid')} body={GuarantoridTemplate} sortable={true} ></Column>
                                    <Column  field="loanaccountno" header={$t('loanaccountno')} body={LoanaccountnoTemplate} sortable={true} ></Column>
                                    <Column  field="memberid" header={$t('memberid')} body={MemberidTemplate} sortable={true} ></Column>
                                    <Column  field="relationship" header={$t('relationship')}  sortable={true} ></Column>
                                    <Column  field="guaranteeamount" header={$t('guaranteeamount')}  sortable={true} ></Column>
                                    <Column  field="createdat" header={$t('createdat')}  sortable={true} ></Column>
                                    <Column  field="fullname" header={$t('fullname')}  sortable={true} ></Column>
                                    <Column  field="address1" header={$t('address1')}  sortable={true} ></Column>
                                    <Column  field="address2" header={$t('address2')}  sortable={true} ></Column>
                                    <Column  field="mobileno" header={$t('mobileno')}  sortable={true} ></Column>
                                    <Column  field="gender" header={$t('gender')}  sortable={true} ></Column>
                                    <Column  field="marital_status" header={$t('maritalStatus')}  sortable={true} ></Column>
                                    <Column  field="photo" header={$t('photo')} body={PhotoTemplate} sortable={true} ></Column>
                                    <Column  field="id_type" header={$t('idType')}  sortable={true} ></Column>
                                    <Column  field="idcardno" header={$t('idcardno')}  sortable={true} ></Column>
                                    <Column  field="id_image" header={$t('idImage')} body={IdImageTemplate} sortable={true} ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
LoanguarantorListPage.defaultProps = {
	primaryKey: 'guarantorid',
	pageName: 'loanguarantor',
	apiPath: 'loanguarantor/index',
	routeName: 'loanguarantorlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default LoanguarantorListPage;
